import { graphql } from "../gql-tada"

export const activeOrderFragment = graphql(`
  fragment ActiveOrder on Order @_unmask {
    __typename
    id
    active
    code
    createdAt
    couponCodes
    state
    currencyCode
    totalQuantity
    subTotalWithTax
    shippingWithTax
    total
    totalWithTax
    taxSummary {
      description
      taxRate
      taxBase
      taxTotal
    }
    discounts {
      type
      adjustmentSource
      description
      amountWithTax
    }
    lines {
      id
      quantity
      linePriceWithTax
      discountedLinePriceWithTax
      proratedLinePriceWithTax
      productVariant {
        id
        name
        sku
        product {
          id
          name
          slug
        }
        options {
          id
          name
          group {
            id
            name
          }
        }
      }
      featuredAsset {
        id
        preview
      }
    }
    shippingLines {
      shippingMethod {
        id
        description
      }
      priceWithTax
    }
    customer {
      id
      emailAddress
      firstName
      lastName
    }
    shippingAddress {
      fullName
      company
      streetLine1
      streetLine2
      city
      postalCode
      country
      countryCode
      phoneNumber
      province
    }
    billingAddress {
      fullName
      company
      streetLine1
      streetLine2
      city
      postalCode
      country
      countryCode
      phoneNumber
      province
    }
  }
`)

export const GET_ACTIVE_ORDER = graphql(
  `
    query GetActiveOrder {
      activeOrder {
        ...ActiveOrder
      }
    }
  `,
  [activeOrderFragment],
)

export const GET_ORDER_BY_CODDE = graphql(
  `
    query GetOrderByCode($code: String!) {
      orderByCode(code: $code) {
        ...ActiveOrder
      }
    }
  `,
  [activeOrderFragment],
)
